import { StackView, Spinner, ToggleSwitch, Select, Icon, Text } from '@planningcenter/tapestry-react';
import React, { useState, useEffect, useMemo } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import '../../chat_context.js';
import { useChatApi } from '../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { Subheading } from '../ui/subheading.js';

const toSelectOptions = ({ value, name }) => ({ label: name, value });
const Plans = ({ onChange, isActive, values }) => {
    const [options, setOptions] = useState({});
    const [isEnabled, setEnabled] = useState(false);
    const [fetchingCount, setFetchingCount] = useState(0);
    const api = useChatApi();
    const isFetchable = isActive && isEnabled;
    const isInvalid = !isActive && values.teams.length > 0;
    useEffect(() => {
        if (isActive)
            return;
        setEnabled(false);
    }, [isActive]);
    useEffect(() => {
        if (!values.plan_id)
            return;
        setEnabled(true);
    }, [values.plan_id]);
    useEffect(() => {
        if (!isFetchable)
            return;
        values.teams.forEach(({ team_id }) => {
            if (options[team_id])
                return;
            setFetchingCount((c) => c + 1);
            api.services
                .get("chat", { fields: { Chat: "plans" }, plan_id: values.plan_id, team_id })
                .then(({ plans }) => {
                setOptions((prevOptions) => ({ ...prevOptions, [team_id]: plans }));
                setFetchingCount((c) => c - 1);
            });
        });
    }, [values.teams, isFetchable]);
    const availableOptions = useMemo(() => {
        const uniqOptions = values.teams.reduce((acc, { team_id }) => options[team_id]
            ? {
                ...acc,
                ...options[team_id].reduce((obj, option) => ({
                    ...obj,
                    [option.value]: option,
                }), {}),
            }
            : acc, {});
        return Object.values(uniqOptions).map(toSelectOptions);
    }, [values.teams, options]);
    return (React.createElement(StackView, { spacing: 1 },
        React.createElement(StackView, { axis: "horizontal", alignItems: "center", spacing: 1 },
            React.createElement(StackView, { alignItems: "center", axis: "horizontal", marginRight: "auto", spacing: 1 },
                React.createElement(Subheading, null, "Filter by plan"),
                fetchingCount > 0 && React.createElement(Spinner, { size: "xs" })),
            React.createElement(ToggleSwitch, { ariaLabel: "Filter by plan", disabled: !isActive, isChecked: isEnabled, onClick: () => {
                    setEnabled((e) => !e);
                    onChange({
                        appName: "Services",
                        values: (prev) => ({
                            ...prev,
                            plan_id: null,
                        }),
                    });
                } })),
        isEnabled ? (React.createElement(Select, { id: "filter-by-plan-select", value: values.plan_id, defaultValue: null, emptyValue: availableOptions.length ? "Choose a plan" : "No plans available", disabled: availableOptions.length < 1, options: availableOptions, onChange: ({ value }) => onChange({
                appName: "Services",
                values: (prev) => ({
                    ...prev,
                    plan_id: value,
                }),
            }) })) : isInvalid ? (React.createElement(StackView, { axis: "horizontal", alignItems: "center", spacing: 2, padding: 2 },
            React.createElement(Icon, { color: "foregroundSecondary", name: "general.exclamationTriangle", size: "lg" }),
            React.createElement(Text, { size: 5, color: "foregroundSecondary" }, "Plan filtering is not possible using teams from multiple service types. Try choosing teams above with only one service type."))) : null));
};

export { Plans };
//# sourceMappingURL=plans.js.map
